import { render, staticRenderFns } from "./DataTableRow.vue?vue&type=template&id=e4db7598&scoped=true&"
import script from "./DataTableRow.vue?vue&type=script&lang=ts&"
export * from "./DataTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./DataTableRow.vue?vue&type=style&index=0&id=e4db7598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4db7598",
  null
  
)

export default component.exports